import * as T from './actionTypes';

// Contractor cost lines
export const fetchContractorCost = (workOrderId) => ({ type: T.FETCH_CONTRACTOR_COST, payload: workOrderId });
export const fetchContractorCostSuccess = (lines) => ({ type: T.FETCH_CONTRACTOR_COST_SUCCESS, payload: lines });
export const fetchContractorCostFail = (error) => ({ type: T.FETCH_CONTRACTOR_COST_FAIL, payload: error });

export const createContractorCost = (data, callback) => ({ type: T.CREATE_CONTRACTOR_COST, payload: { data, callback } });
export const createContractorCostSuccess = (line) => ({ type: T.CREATE_CONTRACTOR_COST_SUCCESS, payload: line });
export const createContractorCostFail = (error) => ({ type: T.CREATE_CONTRACTOR_COST_FAIL, payload: error });

export const updateContractorCost = (id, data, callback) => ({ type: T.UPDATE_CONTRACTOR_COST, payload: { id, data, callback } });
export const updateContractorCostSuccess = (line) => ({ type: T.UPDATE_CONTRACTOR_COST_SUCCESS, payload: line });
export const updateContractorCostFail = (error) => ({ type: T.UPDATE_CONTRACTOR_COST_FAIL, payload: error });

export const deleteContractorCost = (id, callback) => ({ type: T.DELETE_CONTRACTOR_COST, payload: { id, callback } });
export const deleteContractorCostSuccess = (id) => ({ type: T.DELETE_CONTRACTOR_COST_SUCCESS, payload: id });
export const deleteContractorCostFail = (error) => ({ type: T.DELETE_CONTRACTOR_COST_FAIL, payload: error });

// Aggregate WO cost
export const fetchWorkOrderCost = (workOrderId) => ({ type: T.FETCH_WORK_ORDER_COST, payload: workOrderId });
export const fetchWorkOrderCostSuccess = (cost) => ({ type: T.FETCH_WORK_ORDER_COST_SUCCESS, payload: cost });
export const fetchWorkOrderCostFail = (error) => ({ type: T.FETCH_WORK_ORDER_COST_FAIL, payload: error });

export const clearWorkOrderCostMessages = () => ({ type: T.CLEAR_WORK_ORDER_COST_MESSAGES });
